/* eslint-disable class-methods-use-this */
/**
 * Licent
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import confetti from 'canvas-confetti';

/**
 * Confetti controller.
 */
export default class extends Controller {
  static values = {
    interval: {
      type: Number,
      default: 5000,
    },
  };

  timer = null;

  /**
   * Connect.
   */
  connect() {
    this.fire();
    this.timer = window.setInterval(() => this.fire(), this.intervalValue);
  }

  /**
   * Disconnect.
   */
  disconnect() {
    window.clearInterval(this.timer);
    confetti.reset();
  }

  /**
   * Fire a basic cannon burst.
   */
  fire() {
    confetti({ particleCount: 160, spread: 120, origin: { y: 0.6 } });
  }
}
